import { render, staticRenderFns } from "./HousingAccommodations.vue?vue&type=template&id=cf2f712c&scoped=true&"
import script from "./HousingAccommodations.vue?vue&type=script&lang=js&"
export * from "./HousingAccommodations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2f712c",
  null
  
)

export default component.exports